import {ChangeDetectorRef, Component, OnInit, OnDestroy} from '@angular/core';
//service
import {UserService} from '../service/user.service';
import {OrganizationService} from '../service/organization.service';

import {ApiUserService} from '../service/api-user.service';
// user model
import {User} from '../shared/models/user';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PopupsComponent} from '../modal-edit/popups/popups.component';
import { StoreFilterCount } from '../shared/interfaces/storeFilterCount';

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [OrganizationService]
})

export class MainComponent implements OnInit, OnDestroy {

  userSubscription: any;
  currentUserSubscription: any;

  users: User[] = [];
  usersCount: number = 0;
  usersPage: number = 1;
  apiUsers: User[] = [];
  apiUsersPage: number = 1;
  apiUsersOrderBy: string = 'apiUsersOrderBy';
  apiUsersOrderByDirection = '';
  searchTerm: string;
  statusFilter = null;
  currentUser;
  retrievingUserData = true;
  retrievingApiUserData = true;

  pageSize: number = 10;

  constructor(private userService: UserService,
              private apiUserService: ApiUserService,
              private modalService: NgbModal,
              private cd: ChangeDetectorRef) {
  }

  ngOnInit() {

    this.currentUser = this.userService.currentUserSubject.getValue();

    this.apiUserService.newApiUserSubject.subscribe(user => {
      if (user !== null) {
        this.apiUsers.push(user);
      }
    });

    // this.userService.newStatusSubject.subscribe((result) => {
    //     this.statusFilter = result;
    //   });

    this.userService.newSearchSubject.subscribe((result) => {
      this.searchTerm = result;
    })

    this.userService.newCreatedUserSubject.subscribe(user => {
      if (user !== null) {
        this.users.push(user);
      }
    });

    this.userSubscription = this.userService.getUsers()
      .subscribe(users => {
        this.users = users;

        this.usersPage = 1;
        this.usersCount = users.length;
        this.apiUsersPage = 1;

        // map organization to current users organization
        for (let i = 0; this.users.length > i; i += 1) {
          if (this.currentUser.organization_id === this.users[i].organization_id) {
            this.currentUser.organization_title = this.users[i].organization_title;
            this.userService.currentUserSubject.next(this.currentUser);
          }
        }
        for (let i = 0; this.users.length > i; i += 1) {
          if (this.currentUser.id === this.users[i].id) {
            this.currentUserSubscription = this.userService.currentUserSubject
              .subscribe(((i) => (val) => {
                this.users[i] = val;
                this.cd.detectChanges()
              })(i));
          }
        }

        this.retrievingUserData = false;
      });

    if (this.currentUser.role === 'user') {
      this.apiUserService.getApiUsers().subscribe(users => {
        this.apiUsers = users;
        this.usersCount = users.length;
        this.retrievingApiUserData = false;
      });
    }
  } // end OnInit

  ngOnDestroy() {
    this.userSubscription ? this.userSubscription.unsubscribe() : null;
    this.currentUserSubscription ? this.currentUserSubscription.unsubscribe() : null;
  }

  onStatusToggler(status) {
    switch (status) {
      case 'all':
        this.statusFilter = null;
        return null;
      case 'active':
        this.statusFilter = true;
        break;
      case 'disabled':
        this.statusFilter = false;
        break;
      default:
        break;
    }
  }

  onSetApiUserOrder(order) {
    this.apiUsersPage = 1;
    if (this.apiUsersOrderBy === order) {
      if (this.apiUsersOrderByDirection === '') {
        this.apiUsersOrderByDirection = 'reverse';
      } else {
        this.apiUsersOrderByDirection = '';
      }
    }
    this.apiUsersOrderBy = order;
  }

  disableUser(user) {
    let text = '';
    if (!user.status) {
      text = 'enable';
    } else {
      text = 'disable';
    }

    if (confirm('Are you sure you want to ' + text + ' ' + user.name + '?')) {
      this.userService.ableUser(user, text)
        .subscribe((result) => {
          user.status = !user.status;
        });
    }
  }

  regenerateKey(user) {
    this.apiUserService.regenerateKey(user)
      .subscribe((result) => {
        let modalRef;
        this.userService.setPopupObject(result);
        modalRef = this.modalService.open(PopupsComponent);
      });
  }


  deleteUser(user) {
    let index;
    if (confirm('Are you sure you want to delete ' + user.name + '?')) {
      // regular
      if (user.level) {
        index = this.users.indexOf(user);
        this.users.splice(index, 1);

        this.userService.deleteUser(user)
          .subscribe(null,
            err => {
            });
      } else {

        index = this.apiUsers.indexOf(user);
        this.apiUsers.splice(index, 1);

        this.apiUserService.deleteApiUser(user)
          .subscribe(null,
            err => {
            });
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts